import { createAsyncThunk } from '@reduxjs/toolkit'
import apiClient from '../../../services/axois'
import { convertDate, formatDateToUTC } from '../../../utility/genricFunction'
import { setenrollmentPageData } from '../../slice/enrollment/enrollment.slice'
import { API_ROUTES } from '../../../utility/api.routes'
import { toast } from 'react-toastify'
// this is for demo purpose only / change for further api calls

const constructQueryParams = (filters) => {
  const params = new URLSearchParams()
  Object.keys(filters).forEach((key) => {
    if (filters[key].value !== null && filters[key].value !== undefined && filters[key].value !== '') {
      params.append(key, key == 'enrollmentDate' ? convertDate(filters[key].value) : filters[key].value)
    }
  })
  return params.toString()
}

export const getEnrollment = createAsyncThunk('enrollment/getEnrollment', async (filters, { dispatch }) => {
  try {
    const queryParams = constructQueryParams(filters)
    let url = `/student/enrollments?${queryParams}`
    const response = await apiClient.get(url)
    response?.data?.result?.enrollment?.forEach((student) => {
      const date = student.enrollmentDate !== null && new Date(student.enrollmentDate)
      student.enrollmentDate = student.enrollmentDate !== null && formatDateToUTC(date)
    })
    dispatch(setenrollmentPageData(response?.data?.result))
    return response?.data?.result?.enrollment // todo: need to store only "result" array inside redux state
  } catch (error) {
    console.error('builder function error:', error)
    throw error
  }
})

export const createEnrollment = createAsyncThunk(
  'enrollment/createEnrollment',
  async ({ inquiryId, payload, navigate }) => {
    try {
      if(inquiryId){
        const url = API_ROUTES.ENROLLMENT.POST_STUDENT_ENROLLMENT(inquiryId)
        const response = await apiClient.post(url, payload)
        if (response?.data?.status) {
          navigate('/enrollment')
          toast.success(response.data.message, {
            className: 'custom-toast-success',
            progressStyle: { background: '#ffffff' },
          })
        }
      } else {
        const url = API_ROUTES.ENROLLMENT.POST_EXIST_STUDENT_ENROLLMENT
        const response = await apiClient.post(url, payload)
        if (response?.data?.status) {
          navigate('/enrollment')
          toast.success(response.data.message, {
            className: 'custom-toast-success',
            progressStyle: { background: '#ffffff' },
          })
        }
      }
      // return response?.data?.result
    } catch (error) {
      toast.error(error.response.data.message, {
        className: 'custom-toast-error',
        progressStyle: { background: '#C53C43' },
      })
      throw error
    }
  },
)

export const archiveEnrollment = createAsyncThunk('faculty/archiveEnrollment', async (studentId) => {
  try {
    const response = await apiClient.post(`/student/${studentId}/archive`, {
      userStatus: 'archive',
    })
    toast.success(response.data.message, {
      className: 'custom-toast-success',
      progressStyle: { background: '#ffffff' },
    })
  } catch (error) {
    toast.error(error.response.data.message, {
      className: 'custom-toast-error',
      progressStyle: { background: '#C53C43' },
    })
    console.error('builder function error:', error)
    throw error
  }
})

export const transferBatchOrBranch = createAsyncThunk('faculty/transferBatchOrBranch', async (data, { dispatch }) => {
  try {
    const studentId = data.studentId
    const transferredBatchOrBranchData = {
      branchId: data.branch,
      batchId: data.batch,
    }

    const response = await apiClient.post(`/student/${studentId}/assign/branch/batch`, transferredBatchOrBranchData)
    dispatch(getEnrollment())
    toast.success(response.data.message, {
      className: 'custom-toast-success',
      progressStyle: { background: '#ffffff' },
    })
  } catch (error) {
    toast.error(error.response.data.message, {
      className: 'custom-toast-error',
      progressStyle: { background: '#C53C43' },
    })
    console.error('builder function error:', error)
    throw error
  }
})

export const editStudentEnrollmentData = createAsyncThunk(
  'enrollment/editStudentEnrollment',
  async ({ payload, id, navigate }) => {
    const url = API_ROUTES.ENROLLMENT.PUT_STUDENT_ENROLLMENT(id)
    try {
      const result = await apiClient.put(url, payload)

      if (result?.data?.status) {
        navigate('/enrollment')
        toast.success(result.data.message, {
          className: 'custom-toast-success',
          progressStyle: { background: '#ffffff' },
        })
      }
      // dispatch(getEnrollment())
    } catch (error) {
      toast.error(error.response.data.message, {
        className: 'custom-toast-error',
        progressStyle: { background: '#C53C43' },
      })
      console.error('builder function error:', error)
      throw error
    }
  },
)

export const getStudentFeeStructure = createAsyncThunk('enrollment/getStudentFeeStructure', async ({ studentId }) => {
  try {
    let url = API_ROUTES.ENROLLMENT.GET_STUDENT_FEE_STRUCTURE(studentId)
    const response = await apiClient.get(url)
    return response?.data?.result // todo: need to store only "result" array inside redux state
  } catch (error) {
    console.error('builder function error:', error)
    throw error
  }
})
export const getFeeStructure = createAsyncThunk(
  'enrollment/getFeeStructure',
  async ({ courseId, batchId, branchId }) => {
    // try {
    let url = API_ROUTES.ENROLLMENT.GET_FEE_STRUCTURE(courseId, batchId, branchId)
    const response = await apiClient.get(url)
    if (response.status) {
      return response?.data?.result // todo: need to store only "result" array inside redux state
    } else {
      //TODO: show tosty notification
      return null // todo: need to store only "result" array inside redux state
    }
    // } catch (error) {
    //   console.error('builder function error:', error)
    //   throw error
    // }
  },
)

export const getBranchList = createAsyncThunk('enrollment/getBranchList', async ({courseId, courseBranchesFess}) => {
  const url  = courseBranchesFess ? `/branch/batch/${courseId}?courseBranchesFess=${courseBranchesFess} ` : `/branch/batch/${courseId}`

  try {
    // let url = API_ROUTES.ENROLLMENT.GET_BRANCH_LIST(courseId)
    const response = await apiClient.get(url)
    const branch = response?.data?.result.map((branches) => {
      return branches 
    }) // todo: need to store only "result" array inside redux state
    return branch
  } catch (error) {
    console.error('builder function error:', error)
    throw error
  }
})

export const getCourseFees = createAsyncThunk('enrollment/getCourseFees', async ({ courseId, batchId }) => {
  try {
    let url = API_ROUTES.ENROLLMENT.GET_COURSE_FEES(courseId, batchId)
    const response = await apiClient.get(url)
    return response?.data?.result // todo: need to store only "result" array inside redux state
  } catch (error) {
    console.error('builder function error:', error)
    throw error
  }
})
